package playground.gradient.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectDragGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp

@Composable
fun BoxScope.StartEndDragHandle(
    anchor: Offset,
    setAnchor: (Offset) -> Unit,
    dragAreaIntSize: IntSize,
) {
    val anchorState by rememberUpdatedState(anchor)
    Box(
        Modifier
            .align(Alignment.TopStart)
            .offset {
                val padding = 16.dp.roundToPx()
                IntOffset(
                    (anchorState.x * (dragAreaIntSize.width - padding)).toInt(),
                    (anchorState.y * (dragAreaIntSize.height - padding)).toInt(),
                )
            }

            .shadow(
                elevation = 10.dp,
                shape = CircleShape
            )
            .background(
                color = Color.White,
                shape = CircleShape
            )
            .clip(CircleShape)
            .pointerHoverIcon(PointerIcon.Hand)
            .pointerInput(dragAreaIntSize) {
                detectDragGestures { _, dragAmount ->
                    val newStartX = anchorState.x + (dragAmount.x / dragAreaIntSize.width)
                    val newStartY = anchorState.y + (dragAmount.y / dragAreaIntSize.height)

                    setAnchor(Offset(
                        newStartX.coerceIn(0f..1f),
                        newStartY.coerceIn(0f..1f),
                    ))
                }
            }
//            .border(
//                width = 2.dp,
//                color = Color.White,
//                shape = CircleShape
//            )
            .size(16.dp)

    )
}